import React from 'react';
import { Modal, Button } from 'flowbite-react';
import { useTranslation } from 'react-i18next';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'; // Or similar warning icon

interface DeleteConfirmationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    title: string;
    message: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ isOpen, onClose, onConfirm, title, message }) => {
    const { t, i18n } = useTranslation();
    const isRtl = i18n.dir() === 'rtl';

    return (
        <Modal show={isOpen} onClose={onClose} size="md" popup>
            <div className="relative bg-white rounded-lg shadow dark:bg-gray-700">
                <button
                    type="button"
                    className={`absolute top-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-800 dark:hover:text-white ${isRtl ? 'left-2.5' : 'right-2.5'}`}
                    onClick={onClose}
                >
                    <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                    <span className="sr-only">Close modal</span>
                </button>
                <div className="p-6 text-center">
                    <ExclamationTriangleIcon className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                    {title && <h3 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">{title}</h3>}
                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                        {message}
                    </h3>
                    <div className="flex justify-center gap-4">
                        <Button color="failure" onClick={onConfirm}>
                            {t('checklistCustomization.modals.confirmDelete', { defaultValue: 'Yes, I\'m sure' })}
                        </Button>
                        <Button color="gray" onClick={onClose}>
                            {t('checklistCustomization.modals.cancel', { defaultValue: 'No, cancel' })}
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteConfirmationModal;
